/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attached a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Global add-to-cart handler for pages where no section-specific handler exists (e.g. product page).
// Section-specific handlers (featured-collection, cart) call stopPropagation, so they won't reach here.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="add-to-cart"]');
  if (!btn) return;
  if (!window.theme || window.theme.cartType === 'page') return;

  var form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();

  btn.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  var formData = W.serialize(form);

  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  }).then(function(response) {
    btn.removeAttribute('disabled');
    if (response.ok) {
      var quantityEl = form.querySelector('[name="quantity"]');
      var quantity = quantityEl ? parseInt(quantityEl.value) || 1 : 1;
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: btn, variant: null, quantity: quantity }
      }));
    } else {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }).catch(function() {
    btn.removeAttribute('disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
});




